export default __webpack_public_path__ + "static/media/ordinacija_W626-DIAMANT-2X12,5.4d5b8ef0.jpg";